/**
 * Kuerzt die Beschriftung im Warenkorb, wenn sie neben ihrer Angabe nicht mehr
 * hinpasst.
 *
 * Unter dem Bild stehen rund 53 Pixel zur Verfuegung. "Größe" neben einem
 * schmalen Plaettchen wie "S" geht sich darin aus, neben "3XL" nicht mehr.
 * Frueher rutschte die Angabe dann in eine zweite Zeile - beide sollen aber
 * nebeneinander bleiben.
 *
 * Gekuerzt wird deshalb das Wort, und zwar auf seine ersten beiden Buchstaben
 * mit Punkt: aus "Größe" wird "Gr.". Das ist als Abkuerzung lesbar, waehrend
 * ein abgeschnittenes Wort ("Grö...") nur nach einem Fehler aussieht. Reicht
 * selbst das nicht, greift die Regel im Stylesheet und schneidet ab - besser
 * ein angeschnittenes Wort als eine zerrissene Zeile.
 *
 * Nicht jedes Wort vertraegt das. "Druckformate" wurde zu "Dr." und sagte
 * damit gar nichts mehr, "Format" zu "Fo.". Wo der Wert daneben ohnehin fuer
 * sich spricht - "A4", "Tassenformat", "80 cm" - traegt die Beschriftung
 * das Merkmal data-dp-ohne-kurz: sie verschwindet dann lieber ganz, statt
 * als Stummel dazustehen.
 *
 * Gemessen statt gerechnet: wie breit ein Wort faellt, haengt an der Schrift,
 * und wie breit das Plaettchen daneben faellt, an seinem Inhalt.
 */
const MARKE = '.dp-korb-option:only-child .dp-korb-marke, .dp-korb-perso-marke';

/**
 * Passt eine einzelne Beschriftung an.
 *
 * @param {HTMLElement} marke
 */
function pruefeAlle() {
  for (const marke of document.querySelectorAll(MARKE)) pruefe(marke);
}

function pruefe(marke) {
  // Der volle Wortlaut wird beim ersten Mal vermerkt - danach ist er weg.
  if (marke.dataset.dpVoll === undefined) {
    marke.dataset.dpVoll = marke.textContent.trim();
  }

  const voll = marke.dataset.dpVoll;
  if (voll.length < 4) return;

  /*
   * Erst wieder ausschreiben und wieder zeigen, dann messen: sonst bliebe
   * die Abkuerzung stehen, wenn der Platz wieder reicht.
   */
  if (marke.textContent !== voll) marke.textContent = voll;
  if (marke.hidden) marke.hidden = false;
  if (marke.scrollWidth <= marke.clientWidth + 0.5) return;

  if (marke.dataset.dpOhneKurz !== undefined) {
    marke.hidden = true;
    return;
  }

  /*
   * Wo die ersten beiden Buchstaben kein brauchbares Wort ergeben, steht die
   * Abkuerzung am Element selbst - "Personalisierung" wuerde sonst zu "Pe.".
   */
  marke.textContent = marke.dataset.dpKurz || voll.slice(0, 2) + '.';
}

let angemeldet = false;

/*
 * Zusammengefasst auf ein Bild: der Beobachter unten haengt am ganzen Dokument
 * und meldet sich bei jeder Aenderung, auch bei solchen, die den Warenkorb gar
 * nicht betreffen.
 */
function laufe() {
  if (angemeldet) return;
  angemeldet = true;

  /*
   * Ein Zeitgeber und kein Bildaufruf: gemessen wird ohnehin auf Anforderung,
   * und der Zeitgeber laeuft auch dort, wo der Browser gerade nicht zeichnet -
   * etwa in einem Reiter im Hintergrund.
   */
  setTimeout(() => {
    angemeldet = false;
    pruefeAlle();

    /*
     * Noch zwei Blicke danach. Die Warenkorb-Schublade faehrt ein, und
     * waehrend der Bewegung ist sie schmaler oder breiter als am Ende -
     * gemessen wurde dann eine Breite, die es gleich nicht mehr gibt. Nach
     * der Bewegung aendert sich nichts mehr am Baum, der Beobachter meldet
     * sich also kein zweites Mal von selbst.
     */
    for (const wann of [250, 600]) setTimeout(pruefeAlle, wann);
  }, 0);
}

/*
 * Der Warenkorb baut sich bei jeder Aenderung neu auf - Menge, Loeschen, ein
 * Rabattcode. Das Skript laeuft dabei nicht noch einmal an, sein Ergebnis
 * waere also nach dem ersten Handgriff verschwunden.
 */
new MutationObserver(laufe).observe(document.documentElement, {
  childList: true,
  subtree: true,

  /*
   * Auch auf das Aufklappen hoeren: das Feld "Personalisierung" nimmt dabei
   * die volle Breite ein, sein Wort passt dann wieder ganz hinein.
   */
  attributes: true,
  attributeFilter: ['open'],
});

window.addEventListener('resize', laufe, { passive: true });
laufe();
